var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-item-group",
    _vm._b(
      {
        attrs: {
          "active-class": "primary"
        },
        on: {
          change: _vm.emitData
        },
        model: {
          value: _vm.model,
          callback: function callback($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      },
      "v-item-group",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "v-row",
        [
          _vm._l(_vm.items, function(item, key) {
            return _c(
              "v-col",
              {
                key: key,
                attrs: {
                  cols: "12",
                  md: _vm.cols
                }
              },
              [
                _c("v-item", {
                  attrs: {
                    value: item.key
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function fn(_ref) {
                          var active = _ref.active,
                            toggle = _ref.toggle
                          return [
                            !_vm.theme
                              ? _c(
                                  "v-card",
                                  {
                                    staticClass: "app-card d-flex align-center",
                                    attrs: {
                                      height: "230"
                                    },
                                    on: {
                                      click: toggle
                                    }
                                  },
                                  [
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass: "text-center",
                                        style: _vm.cardActiveStyle(active)
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "py-4"
                                          },
                                          [
                                            _vm.svg
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "40"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.wizardIcon(item)
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "v-avatar",
                                                  [
                                                    _c("v-img", {
                                                      staticClass: "ma-auto",
                                                      attrs: {
                                                        src: _vm.wizardIcon(
                                                          item
                                                        ),
                                                        "max-height": "60",
                                                        contain: ""
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        ),
                                        _c("h3", [
                                          _vm._v(" " + _vm._s(item.name) + " ")
                                        ]),
                                        item.subtitle
                                          ? _c("h5", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.subtitle) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm.pluginsDialog
                                          ? [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "mb-1 caption"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.description) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      style: _vm.cardActiveStyle(
                                                        active
                                                      ),
                                                      attrs: {
                                                        href: "#"
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          $event.preventDefault()
                                                          return _vm.openDialog(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("More Info")]
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _c(
                                          "gg-btn",
                                          {
                                            staticClass: "mt-5",
                                            attrs: {
                                              tile: "",
                                              color: active
                                                ? "white"
                                                : "primary",
                                              outlined: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  active ? "Selected" : "Select"
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "v-card",
                                  {
                                    staticClass: "app-card",
                                    on: {
                                      click: toggle
                                    }
                                  },
                                  [
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass: "text-center pa-0",
                                        style: _vm.cardActiveStyle(active)
                                      },
                                      [
                                        _c("v-img", {
                                          staticClass:
                                            "d-flex align-center ma-auto",
                                          style: active
                                            ? "border: 1px solid #0ca750"
                                            : "",
                                          attrs: {
                                            src: "/static/img/wizard/themes/".concat(
                                              item.key,
                                              ".png"
                                            )
                                          }
                                        }),
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "py-2"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.name) + " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          }),
          _vm.dialog
            ? _c("plugin-dialog", {
                attrs: {
                  dialog: _vm.dialog,
                  name: _vm.dialogItem.name,
                  description: _vm.dialogItem.description_long,
                  "image-path": _vm.wizardIcon(_vm.dialogItem),
                  website: _vm.dialogItem.url
                },
                on: {
                  close: _vm.closeDialog
                }
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }